import PropTypes from 'prop-types';
import React from 'react';

import {IMASK_PATTERNS} from '../../../constants/imaskPatterns';
import {IMaskInputWrapper} from '../../../shared/components/IMaskInputWrapper';

const BankBranchInput = (props) => {
  return (
    <IMaskInputWrapper
      data-testid="bank-branch-input"
      className="input-message"
      type="text"
      name="message"
      id="message"
      onChange={props.onChange}
      mask={IMASK_PATTERNS.BANK_BRANCH}
      autoComplete="off"
      placeholder="Digite a sua agência bancária sem o dígito"
    />
  );
};

BankBranchInput.propTypes = {
  onChange: PropTypes.func
};

export default BankBranchInput;
